import TssModal from './modules/modal'

let webcamModal

/* Messages */
function handleMessage(e) {
  if (e.data.type === 'tss:open-modal') {
    if (!webcamModal) webcamModal = new TssModal(document.body)
    webcamModal.open(e.data.url)
  }
  if (e.data.type === 'tss:resize') {
    const iframe = document.getElementById('tss-widget')
    if (iframe) {
      iframe.style.height = e.data.height + 'px'
    }
  }
}

window.addEventListener('message', handleMessage, false)
